var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSubmitIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 0C5.14933 0 0 5.14933 0 11.5C0 17.8507 5.14933 23 11.5 23C17.8507 23 23 17.8507 23 11.5C23 5.14933 17.8507 0 11.5 0ZM11.5 21.0491C6.22746 21.0491 1.95089 16.7725 1.95089 11.5C1.95089 6.22746 6.22746 1.95089 11.5 1.95089C16.7725 1.95089 21.0491 6.22746 21.0491 11.5C21.0491 16.7725 16.7725 21.0491 11.5 21.0491Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2232 10.6786H12.3214V6.77678C12.3214 6.66384 12.229 6.57143 12.1161 6.57143H10.8839C10.771 6.57143 10.6786 6.66384 10.6786 6.77678V10.6786H6.77679C6.66384 10.6786 6.57143 10.771 6.57143 10.8839V12.1161C6.57143 12.229 6.66384 12.3214 6.77679 12.3214H10.6786V16.2232C10.6786 16.3362 10.771 16.4286 10.8839 16.4286H12.1161C12.229 16.4286 12.3214 16.3362 12.3214 16.2232V12.3214H16.2232C16.3362 12.3214 16.4286 12.229 16.4286 12.1161V10.8839C16.4286 10.771 16.3362 10.6786 16.2232 10.6786Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmitIcon);
export default __webpack_public_path__ + "static/media/submitIcon.811f7e464a6ba1a72f34b9fa6beafb51.svg";
export { ForwardRef as ReactComponent };